import React, { useEffect, useMemo, useState } from 'react';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { SITE_URLS } from '@constants';
import { DeleteAccount } from '@components/templates/myAccount';
import { useTranslation } from 'react-i18next';
import { useData } from '@hooks/useData';
import { useNotifications } from '@hooks/useNotifications';
import { useCustomNavigate } from '@hooks/useCustomNavigate';

export function DeleteAccountPage() {
    const { t } = useTranslation();
    const { user } = useData();
    const { showDefaultNotification } = useNotifications();
    const { navigate } = useCustomNavigate();
    const [warned, setWarned] = useState(false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const markToDeleteAt = useMemo(() => (user as any)?.data?.markToDeleteAt, [user]);

    const translations = {
        title: t('delete-account-component.metatags.title'),
        description: t('delete-account-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.deleteAccount,
        index: false,
    });

    useEffect(() => {
        if (!warned && markToDeleteAt) {
            setWarned(true);
            showDefaultNotification({ type: 'error', message: t('delete-account-component.errors.already-marked') });
            navigate(`/${SITE_URLS.myProfile}`, { replace: true });
        }
    }, [markToDeleteAt, warned, t, showDefaultNotification, navigate]);

    if (markToDeleteAt) return null;

    return <DeleteAccount />;
}
